import { getTextStyles, styledOmitCustomProps } from '@braskai/ui-kit';

import { css, Slider, sliderClasses, styled } from '@mui/material';

export const SContainer = styled('div')(
  () => css`
    display: flex;
    flex-direction: column;
    padding: 20px 16px 0 16px;
  `,
);

type TSSlider = {
  $disableFromIndex: number;
  $size: number;
};

export const SSlider = styled(
  Slider,
  styledOmitCustomProps,
)<TSSlider>(
  ({ $size, $disableFromIndex, theme, disabled }) => css`
    height: 4px;
    border-radius: 4px;
    margin: 0;
    padding-bottom: 0;

    .${sliderClasses.thumb} {
      height: 16px;
      width: 16px;
      border: 2px solid
        ${$size - 1 === $disableFromIndex || disabled ? theme.palette.grey[200] : theme.palette.primary[600]};
      background-color: ${theme.palette.common.white};
      z-index: 1;

      &:focus,
      &:hover,
      &.Mui-active,
      &.Mui-focusVisible {
        box-shadow: ${theme.customShadows.md};
      }
    }

    .Mui-disabled {
      & .${sliderClasses.thumb} {
        border: 2px solid ${theme.palette.grey[200]};
      }
    }

    .${sliderClasses.markLabel} {
      ${getTextStyles('body-2-md')};
      top: -24px;
      color: ${theme.palette.grey[700]};

      &[data-index='0'] {
        transform: translateX(-20%);
      }

      &[data-index='${$size - 1}'] {
        transform: translateX(-80%);
      }

      ${Array.from({ length: $size + 1 }, (_, index) => index).map((idx) => {
        const isDisabled = idx < $disableFromIndex || $size - 1 === $disableFromIndex || disabled;

        return css`
          &[data-index='${idx}'] {
            color: ${isDisabled ? theme.palette.grey[400] : undefined};
            cursor: ${isDisabled ? 'default' : 'pointer'};
          }
        `;
      })}
    }

    .${sliderClasses.track} {
      border: none;
    }

    .${sliderClasses.rail} {
      opacity: 1;
      background-color: ${theme.palette.grey[200]};
      cursor: pointer;
    }

    .${sliderClasses.mark} {
      display: none;
    }

    ${$disableFromIndex > 0 &&
    css`
      ::after {
        content: '';
        display: block;
        position: absolute;
        top: 50%;
        width: ${($disableFromIndex * 100) / ($size - 1)}%;
        height: 4px;
        background: ${theme.palette.grey[200]};
        cursor: default;
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
        transform: translateY(-50%);
      }
    `}
  `,
);
